// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607291254/js/" + chunkId + "." + {"44":"e8c74740","225":"bf270dfb","481":"4b910615","486":"22264953","770":"d872190b"}[chunkId] + ".0.12095481565554889.chunk.js";
};